import type { TCurrencyCode } from '@/infra/types/common';

export const CURRENCY_CODE_COOKIE = 'currencyCode';
export const DEFAULT_CURRENCY_CODE = 'USD' as TCurrencyCode;
export const DEFAULT_COUNTRY_CODE = 'US';
export const SESSION_COOKIE_NAME = 'user-session-id';

export const SESSION_SKIPPED_KEYS = ['consoleErrCount', 'qm_last_page', 'qm_last_period', 'up_o'];

export const enum BookingChannelTypes {
  fmLink = 'FMLINK',
  openTravel = 'OPENTRAVEL',
}
